<template>
  <div class="error-container">
    错误,无当前路由
    <router-link to="/manage">前往活动页</router-link>
  </div>
</template>

<script>
  export default {
    name: 'name'

  }

</script>

<style scoped>
  .error-container {
    padding: 50px;
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/error.vue